import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  SoftwareAndSaasDevelopmentIcon,
  cloudAndDevops,
  cyberSecurity,
  itSupportAndMaintainance,
  mobileAndAppDevelopment,
} from "../../../../assets/icons/serviceIcon/index";
import WebsiteAppDevelopmentWork from "./WebsiteAppDevelopmentWork";
import { useEffect } from "react";

const items = [
  {
    name: "Custom",
    text: "Your website should feel like you. We design custom websites that match your brand’s personality, balancing creativity with seamless functionality to create an engaging experience that truly stands out.",
  },
  {
    name: "E-commerce",
    text: "A smooth shopping experience keeps customers coming back. We create e-commerce websites that are fast, secure and easy to navigate, making browsing, buying and checkout effortless for your customers.",
  },
  {
    name: "CMS",
    text: "A strong website grows with your business. We build CMS-powered websites that are flexible, well-structured and easy to scale - ensuring smooth updates, great performance, and a hassle-free experience.",
  },
];

const otherService = [
  {
    icon: mobileAndAppDevelopment,
    name: "Mobile App Development",
    des: "We build apps that feel smooth, look great, and keep your users hooked.",
    path: "/mobile-app-development",
  },
  {
    icon: cloudAndDevops,
    name: "Cloud & DevOps Solutions",
    des: "No tech headaches - just fast, secure, and hassle-free cloud solutions.",
    path: "/cloud-devops-development",
  },
  {
    icon: SoftwareAndSaasDevelopmentIcon,
    name: "Software & SaaS Development",
    des: "Smart, scalable, and built for the long run - software that grows with you.",
    path: "/software-saas-development",
  },
  {
    icon: cyberSecurity,
    name: "Cybersecurity & Data Protection",
    des: "Your data stays yours! We lock it down so hackers don’t stand a chance.",
    path: "/cybersecurity-data-protection",
  },
  {
    icon: itSupportAndMaintainance,
    name: "IT Support & Maintenance",
    des: "Seamless IT services to protect and power your business growth.",
    path: "/it-support-maintenance",
  },
];

const WebsiteAndAppDevelopment = () => {
    useEffect(() => {
    // Set Page Title
    document.title = "Web & Web App Development Services | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Custom web and web app development services using modern technologies. TechQilla builds fast, scalable, and secure digital solutions.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Web & Web App Development Services");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", "https://www.techqilla.com/web-app-development");
    }, []);
  
  return (
    <div>
      <NewCommonServiceHero
        heading="Website & Web App"
        colorHeading="Development"
        description="A powerful website is your brand’s strongest storyteller. We craft websites that tell stories, create connections, and make your brand unforgettable."
      />
      <NewCommonServiceForm title="website & app development" items={items} />
      <WebsiteAppDevelopmentWork />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default WebsiteAndAppDevelopment;
